import Cable from 'actioncable';

const consumer = Cable.createConsumer(
  `${process.env.REACT_APP_BASE_URL}/cable?rider_token=${localStorage.getItem(
    'authToken'
  )}`
);

export default consumer;
